import { Box } from "@similarweb/ui-components";
import styled from "styled-components";

export const TableContainer = styled(Box)<{ loading: boolean }>`
    pointer-events: ${({ loading }) => (loading ? "none" : "all")};
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100%;
`;
